import { httpPost, httpPut, httpGet } from '../../Util/http';
import { routeActions } from 'redux-simple-router';
import { addAlert } from '../../MsgNotify/msgNotifyActions';


export const GET_SALARY_OBJECT_REQUEST = 'GET_SALARY_OBJECT_REQUEST'
export const getSalaryObjectRequest = () => {
    return {
        type: GET_SALARY_OBJECT_REQUEST
    }
}

export const GET_SALARY_OBJECT_SUCCESS = 'GET_SALARY_OBJECT_SUCCESS'
export const getSalaryObjectSuccess = (json) => {
    return {
        type: GET_SALARY_OBJECT_SUCCESS,
        periods: json.periods,
        projects: json.projects,
        employees: json.employees,
        days: json.days,
        conflictingProjects: json.conflictingProjects
    }
}

export const GET_SALARY_OBJECT_FAILURE = 'GET_SALARY_OBJECT_FAILURE'
export const getSalaryObjectFailure = () => {
    return {
        type: GET_SALARY_OBJECT_FAILURE
    }
}

export const attemptGetSalaryObject = (projectIds, startDate, endDate) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/salary";
    return (dispatch) => {
        dispatch(getSalaryObjectRequest());
        return httpPost(_url, { projectIds: projectIds, dateFrom: startDate, dateTo: endDate })
            .then(response => {
                return response.json();
            })
            .then((json) => dispatch(getSalaryObjectSuccess(json)))
            .catch(() => {
                dispatch(getSalaryObjectFailure());
                dispatch(routeActions.push("/lon"))
                dispatch(addAlert("Noget gik galt i lønkørlsen."))
            })
    }
}


export const UPDATE_DAY_REQUEST = 'UPDATE_DAY_REQUEST'
export const updateDayRequest = (dayId, normalHours, supplementRate, supplementHours, mileageNew, shackNew, updateObject) => {
    return {
        type: UPDATE_DAY_REQUEST,
        dayId: dayId,
        normalHours: normalHours,
        supplementRate: supplementRate,
        supplementHours: supplementHours,
        updateObject: updateObject,
        mileageNew: mileageNew,
        shackNew: shackNew
    }
}

export const UPDATE_DAY_SUCCESS = 'UPDATE_DAY_SUCCESS'
export const updateDaySuccess = () => {
    return {
        type: UPDATE_DAY_SUCCESS

    }
}

export const UPDATE_DAY_FAILURE = 'UPDATE_DAY_FAILURE'
export const updateDayFailure = (dayId, oldDayState) => {
    return {
        type: UPDATE_DAY_FAILURE,
        dayId: dayId,
        oldDayState: oldDayState
    }
}

export const attemptUpdateDay = (dayId, normalHours, supplementRate, supplementHours, mileageNew, shackNew, updateObject, getState, dispatch) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/salary/update";
    let oldDayState = getState().salaryReducer.days[dayId];
    dispatch(updateDayRequest(dayId, normalHours, supplementRate, supplementHours, mileageNew, shackNew, updateObject));
    return httpPut(_url, {
        id: dayId,
        normalHours: normalHours,
        supplementRate: supplementRate,
        supplementHours: supplementHours,
        milage: mileageNew,
        shack: shackNew
    })
        .then(() => dispatch(updateDaySuccess()))
        .catch(() => {
            dispatch(updateDayFailure(dayId, oldDayState));
        })
}


export const attemptUpdateCell = (dayId, normalHours, supplementRate, supplementHours, mileageNew, shackNew, updateObject, absenceCode) => {
    return (dispatch, getState) => {
        return attemptUpdateDay(dayId, normalHours, supplementRate, supplementHours, mileageNew, shackNew, updateObject, getState, dispatch).then(() =>
            attemptUpdateAbsence(dayId, absenceCode, updateObject, getState, dispatch)
        )
    }
}



export const UPDATE_PERIOD_INPUT_REUQEST = 'UPDATE_PERIOD_INPUT_REUQEST'
export const updatePeriodInputRequest = (periodId, type, value, updateObject) => {
    return {
        type: UPDATE_PERIOD_INPUT_REUQEST,
        periodId: periodId,
        inputType: type,
        value: value,
        updateObject: updateObject
    }
}

export const UPDATE_PERIOD_INPUT_SUCCESS = 'UPDATE_PERIOD_INPUT_SUCCESS'
export const updatePeriodInputSuccess = () => {
    return {
        type: UPDATE_PERIOD_INPUT_SUCCESS

    }
}

export const UPDATE_PERIOD_INPUT_FAILURE = 'UPDATE_PERIOD_INPUT_FAILURE'
export const updatePeriodInputFailure = (periodId, oldPeriodState) => {
    return {
        type: UPDATE_PERIOD_INPUT_FAILURE,
        periodId: periodId,
        oldPeriodState: oldPeriodState
    }
}

export const attemptUpdatePeriodInput = (periodId, type, value, updateObject) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/salary/updatePeriodInput";
    return (dispatch, getState) => {
        let oldPeriodState = getState().salaryReducer.periods[periodId];
        dispatch(updatePeriodInputRequest(periodId, type, value, updateObject));
        return httpPut(_url, { id: periodId, type: type, value: value })
            .then(() => dispatch(updatePeriodInputSuccess()))
            .catch(() => {
                dispatch(updatePeriodInputFailure(periodId, oldPeriodState));
            })
    }
}



export const SET_UPDATE_OBJECT = 'SET_UPDATE_OBJECT'
export const setUpdateObject = (updateObject) => {
    return {
        type: SET_UPDATE_OBJECT,
        updateObject: updateObject
    }
}


export const SET_CALCULATOR_OPEN = 'SET_CALCULATOR_OPEN'
export const setOpenCalculator = (dayId, updateObject) => {
    return {
        type: SET_CALCULATOR_OPEN,
        dayId: dayId,
        updateObject: updateObject
    }
}






export const UPDATE_ABSENCE_REQUEST = 'UPDATE_ABSENCE_REQUEST'
export const updateAbsenceRequest = (dayId, absenceCode, updateObject) => {
    return {
        type: UPDATE_ABSENCE_REQUEST,
        dayId: dayId,
        absenceCode: absenceCode,
        updateObject: updateObject
    }
}

export const UPDATE_ABSENCE_SUCCESS = 'UPDATE_ABSENCE_SUCCESS'
export const updateAbsenceSuccess = () => {
    return {
        type: UPDATE_ABSENCE_SUCCESS

    }
}

export const UPDATE_ABSENCE_FAILURE = 'UPDATE_ABSENCE_FAILURE'
export const updateAbsenceFailure = (dayId, oldAbsence) => {
    return {
        type: UPDATE_ABSENCE_FAILURE,
        dayId: dayId,
        oldAbsence: oldAbsence
    }
}

export const attemptUpdateAbsence = (dayId, absenceCode, updateObject, getState, dispatch) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/salary/updateAbsence";
    let oldAbsence = getState().salaryReducer.days[dayId].absenceCode;
    dispatch(updateAbsenceRequest(dayId, absenceCode, updateObject));
    return httpPut(_url, {
        id: dayId,
        absenceCode: absenceCode
    })
        .then(() => dispatch(updateAbsenceSuccess()))
        .catch(() => {
            dispatch(updateAbsenceFailure(dayId, oldAbsence));
        })
}



export const attemtUpdateDayConflicting = (dayId, conflictsWith, employeeId, projectId, conflictingProjects) => {
    return (dispatch, getState) => {



        let updateObject = {
            dayId: dayId,
            employeeId: employeeId,
            projectId: projectId
        }
        //find the period id
        getState().salaryReducer.projects[projectId].periodIds.forEach((periodId) => {
            let split = periodId.split("&");
            if (split[0] === employeeId) {
                updateObject.periodId = periodId
            }
        })

        if (conflictsWith) {
            let newConflictingProjects = getState().salaryReducer.conflictingProjects;
            Object.keys(conflictingProjects).forEach((key) => {
                newConflictingProjects[key] = conflictingProjects[key];
            })
            dispatch(markDayConflicting(dayId, conflictsWith, updateObject, newConflictingProjects))
        }
        else {
            dispatch(markDayConflictSolved(dayId, updateObject))
        }

    }
}


export const MARK_DAY_CONFLICTING = 'MARK_DAY_CONFLICTING'
export const markDayConflicting = (dayId, conflictsWith, updateObject, newConflictingProjects) => {
    return {
        type: MARK_DAY_CONFLICTING,
        dayId: dayId,
        conflictsWith: conflictsWith,
        updateObject: updateObject,
        newConflictingProjects: newConflictingProjects
    }
}



export const MARK_DAY_CONFLICT_SOLVED = 'MARK_DAY_CONFLICT_SOLVED'
export const markDayConflictSolved = (dayId, updateObject) => {
    return {
        type: MARK_DAY_CONFLICT_SOLVED,
        dayId: dayId,
        updateObject: updateObject
    }
}




export const GET_EMPLOYEE_SUGGESTIONS_SUCCESS = 'GET_EMPLOYEE_SUGGESTIONS_SUCCESS';
export function getEmployeeSuggestionsSuccess(suggestions) {
    return {
        type: GET_EMPLOYEE_SUGGESTIONS_SUCCESS,
        suggestions: suggestions,
        updateObject: {
            periodId: "noId"
        }
    }
}



export function getEmployeeSuggestions(val, projectId) {

    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "/api/employee/search?query=" + val
    return (dispatch, getState) => {
        if (!val) {
            dispatch(getEmployeeSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                let alreadyChosen = getState().salaryReducer.projects[projectId].employeeIds;
                var jsonReponse = stripSuggestions(json, alreadyChosen)
                dispatch(getEmployeeSuggestionsSuccess(jsonReponse))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}

function stripSuggestions(suggestions, alreadyChosen) {
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function (chosen) {
            if (chosen === suggestion.id) allowedSugg = false;
        });
        if (allowedSugg) newSuggestions.push({ id: suggestion.id, name: suggestion.id + " - " + suggestion.name });
    })
    return newSuggestions;

}




export const ADD_EMPLOYEE_TO_PROJECT_REQUEST = 'ADD_EMPLOYEE_TO_PROJECT_REQUEST'
export const addEmployeeToProjectRequest = () => {
    return {
        type: ADD_EMPLOYEE_TO_PROJECT_REQUEST
    }
}

export const ADD_EMPLOYEE_TO_PROJECT_SUCCESS = 'ADD_EMPLOYEE_TO_PROJECT_SUCCESS'
export const addEmployeeToProjectSuccess = (json, projectId) => {
    return {
        type: ADD_EMPLOYEE_TO_PROJECT_SUCCESS,
        period: json.period,
        employee: json.employee,
        days: json.days,
        projectId: projectId
    }
}

export const ADD_ALREADY_EXISTING_EMPLOYEE_TO_PROJECT_SUCCESS = 'ADD_ALREADY_EXISTING_EMPLOYEE_TO_PROJECT_SUCCESS'
export const addAlreadyExistingEmployeeToProjectSuccess = (json, projectId) => {
    return {
        type: ADD_ALREADY_EXISTING_EMPLOYEE_TO_PROJECT_SUCCESS,
        period: json.period,
        employee: json.employee,
        days: json.days,
        projectId: projectId
    }
}

export const ADD_EMPLOYEE_TO_PROJECT_FAILURE = 'ADD_EMPLOYEE_TO_PROJECT_FAILURE'
export const addEmployeeToProjectFailure = () => {
    return {
        type: ADD_EMPLOYEE_TO_PROJECT_FAILURE
    }
}

export const attemtAddEmployeeToProject = (employeeId, projectId, dateFrom, dateTo) => {
    var _url = process.env.REACT_APP_webApiEndPoint + "api/salary/addEmployee";
    return (dispatch, getState) => {
        dispatch(addEmployeeToProjectRequest());
        return httpPost(_url, { projectId: projectId, employeeId: employeeId, dateFrom: dateFrom, dateTo: dateTo })
            .then(response => {
                return response.json();
            })
            .then((json) => {
                if (getState().salaryReducer.employees[employeeId])
                    dispatch(addAlreadyExistingEmployeeToProjectSuccess(json, projectId))
                else
                    dispatch(addEmployeeToProjectSuccess(json, projectId))
                dispatch(getEmployeeSuggestionsSuccess([]))
            })
            .catch(() => {
                dispatch(addEmployeeToProjectFailure());
                dispatch(addAlert("Noget gik galt i tilføjelsen af medarbejder"))
            })
    }
}



// WEBPACK FOOTER //
// ./src/App/Project/Salary/actions.js